
import {Brain} from "../logic/brain.js"

export const brain = new Brain()

